module.exports = __webpack_public_path__ + "static/grandata_transparent-f99f25729b277e0bde496a65f3184e84.png";